// components/auth/AuthProviders.tsx
import { ProviderConnectionForm, providerNames } from '#app/utils/connections'

export function AuthProviders({
	type,
	redirectTo,
	userType,
}: {
	type: 'Continue' | 'Login'
	redirectTo?: string | null
	userType?: 'tenant' | 'landlord'
}) {
	// Always ride userType along on redirectTo — it's stored in the redirect
	// cookie at OAuth initiation and read back in the provider callback
	// (Google's callback URL can't carry our params). Without a redirectTo,
	// fall back to '/' so the userType signal still travels.
	const base = redirectTo && redirectTo.trim() !== '' ? redirectTo : '/'
	const redirectToWithUserType = userType
		? `${base}${base.includes('?') ? '&' : '?'}userType=${userType}`
		: redirectTo

	return (
		<ul className="flex flex-col gap-5 py-5 pb-14">
			{providerNames.map((providerName) => (
				<>
					<div
						className="flex items-center w-full md:max-w-[500px] m-auto"
						key={providerName}
					>
						<div className="flex-grow border-t border-[#CCCCCC]" />
						<span className="px-3 text-[#747474] text-[16px]">Or</span>
						<div className="flex-grow border-t border-[#CCCCCC]" />
					</div>
					<li key={providerName}>
						<ProviderConnectionForm
							type={type}
							providerName={providerName}
							redirectTo={redirectToWithUserType}
						/>
					</li>
				</>
			))}
		</ul>
	)
}
